import { c as _c } from "react/compiler-runtime";
import { MaterialIcon, MaterialNameType } from "@website/icons/material";
import { SnackBarProperties } from "@website/ui/snackbar-v2/types";
import { useEffect, useRef } from "react";
export const SnackBarV2 = t0 => {
  const $ = _c(32);
  const {
    severity: t1,
    title,
    Action,
    size: t2,
    onClose,
    duration,
    disableLineClamp
  } = t0;
  const severity = t1 === undefined ? "default" : t1;
  const size = t2 === undefined ? "auto" : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      default: "info",
      warning: "warning_amber",
      error: "error_outline",
      success: "check_circle"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const iconTypeConfig = t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      default: "text-on-color-high-emphasis",
      warning: "text-inverse-warning",
      success: "text-success",
      error: "text-inverse-error"
    };
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const iconStyleConfig = t4;
  const timeout = useRef(null);
  let t5;
  let t6;
  if ($[2] !== duration || $[3] !== onClose || $[4] !== title) {
    t5 = () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
      timeout.current = setTimeout(() => {
        onClose(title);
      }, duration || 3000);
      return () => {
        clearTimeout(timeout.current);
      };
    };
    t6 = [duration, onClose, title];
    $[2] = duration;
    $[3] = onClose;
    $[4] = title;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  if (title) {
    const t7 = `${title ? "translate-x-1/2" : "translate-x-[300%]"} ${size === "multi-line" ? "flex-col px-4 pb-1" : "pl-2 pr-4"} bg-inverse-surface fixed bottom-6 right-1/2 z-[60] flex w-full max-w-[90%] gap-1 rounded-lg lg:w-[526px]`;
    const t8 = `flex items-center justify-center text-2xl leading-6 ${iconStyleConfig[severity]}`;
    const t9 = iconTypeConfig[severity] as MaterialNameType;
    let t10;
    if ($[7] !== t9) {
      t10 = <MaterialIcon name={t9} variant="outlined" />;
      $[7] = t9;
      $[8] = t10;
    } else {
      t10 = $[8];
    }
    let t11;
    if ($[9] !== t10 || $[10] !== t8) {
      t11 = <div className={t8}>{t10}</div>;
      $[9] = t10;
      $[10] = t8;
      $[11] = t11;
    } else {
      t11 = $[11];
    }
    const t12 = `text-on-color-high-emphasis text-caption ${disableLineClamp ? "" : "line-clamp-3"}`;
    let t13;
    if ($[12] !== t12 || $[13] !== title) {
      t13 = <div className={t12}>{title}</div>;
      $[12] = t12;
      $[13] = title;
      $[14] = t13;
    } else {
      t13 = $[14];
    }
    let t14;
    if ($[15] !== t11 || $[16] !== t13) {
      t14 = <div className="flex flex-1 items-center justify-start gap-2 py-4">{t11}{t13}</div>;
      $[15] = t11;
      $[16] = t13;
      $[17] = t14;
    } else {
      t14 = $[17];
    }
    const t15 = `flex items-center justify-end ${size === "multi-line" ? "gap-6" : "gap-4"} p-2`;
    let t16;
    if ($[18] !== onClose || $[19] !== title) {
      t16 = () => onClose(title);
      $[18] = onClose;
      $[19] = title;
      $[20] = t16;
    } else {
      t16 = $[20];
    }
    let t17;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <MaterialIcon className="text-on-color-high-emphasis text-2xl leading-6" name="close" />;
      $[21] = t17;
    } else {
      t17 = $[21];
    }
    let t18;
    if ($[22] !== t16) {
      t18 = <button onClick={t16} tabIndex={0}>{t17}</button>;
      $[22] = t16;
      $[23] = t18;
    } else {
      t18 = $[23];
    }
    let t19;
    if ($[24] !== Action || $[25] !== t15 || $[26] !== t18) {
      t19 = <div className={t15}>{Action}{t18}</div>;
      $[24] = Action;
      $[25] = t15;
      $[26] = t18;
      $[27] = t19;
    } else {
      t19 = $[27];
    }
    let t20;
    if ($[28] !== t14 || $[29] !== t19 || $[30] !== t7) {
      t20 = <div className={t7}>{t14}{t19}</div>;
      $[28] = t14;
      $[29] = t19;
      $[30] = t7;
      $[31] = t20;
    } else {
      t20 = $[31];
    }
    return t20;
  }
};